/**
 * @param {number} price
 * @param {number} discountedPrice
 * @return {number}
 */
export const getDiscountPercentage = (price, discountedPrice) => {
  if (price === 0) return 0;
  return Math.round(100 - (discountedPrice / price) * 100);
};
